// 패스네임 제일 마지막꺼 가져오기***********************************************************************************************************************
export const lastPathSegment = (pathname: string) => {
  return pathname.split('/').filter(Boolean).pop() || '';
};

export const secondLastPathSegment = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 1 ? segments[segments.length - 2] : '';
};
